import { CoreType } from "../../Core/Core.Interfaces";
import { GenericTableSchemaInterface } from "../../Table/Table.Interfaces";
import { VarKey } from "../../Variables/Generated/VarKey.Data";

export const FMSPlusPaymentSuccess00Table: GenericTableSchemaInterface = {
  id: "fms-plus-payment-success-00",
  name: "FMS+ Payment Success 00",
  description: "This table contains data regarding how many people were sent emails and texts messages via our FMS+ Payment Success workflows.",
  core: CoreType.STORAGE,
  // bot:"all",
  mapping: {
    c01: {
      name: "Operator Name",
      variable: VarKey.OrgName
    },
    c02: {
      name: "Facility ID",
      variable: VarKey.LocationFMSId
    },
    c03: {
      name: "Tenant ID",
      variable: VarKey.TenantId
    },
    c04: {
      name: "As soon as payment is confirmed SMS"
    },
    c05: {
      name: "As soon as payment is confirmed Email"
    }
  }
};
